import { useEffect, useState } from "react";
import * as R from 'ramda';
export function LibraryRendererComponent({value, cellRendererParams}: any) {
  console.log('entering into library render component',value,cellRendererParams?.library)
  const [
    libraryElement,
    setLibraryElement
  ] = useState<any>([]);
  console.log('LibraryRendererComponent rendering'); // Check if component mounts
  
  useEffect(
    () => {
      console.log('enter into use effect',cellRendererParams?.library)
      if (cellRendererParams?.library) {
        console.log('enter into use effect')
        const libraryData: any = R.find(
          (requestType: any) => parseInt(
            requestType.Value,
            10
          ) === parseInt(
            value,
            10
          ),
          cellRendererParams?.library
        )
        setLibraryElement(libraryData ? libraryData.Text : '')
      }

    },
    [
      libraryElement,
      value
    ]
  );
  console.log(libraryElement,'libraryElement')
  const getRandomTextColor =()=>{
    const red = Math.floor(Math.random() * 128);
const green = Math.floor(Math.random() * 128);
const blue = Math.floor(Math.random() * 128);
const hexRed = red.toString(16).padStart(2, "0");
const hexGreen = green.toString(16).padStart(2, "0");
const hexBlue = blue.toString(16).padStart(2, "0");

const hexCode = `#${hexRed}${hexGreen}${hexBlue}`;
return hexCode;
}
const randomColor = getRandomTextColor();

 return (
    <>

      <div>
       <span
          className={`p-2 rounded-full delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 bg-${randomColor} text-white`}
          style={{ backgroundColor: randomColor }}>

          {libraryElement || null}
        </span>
      </div>
     
    </>
    
  )
}

